import React, { useState } from "react";
import { SlidingCubeLoader } from "react-loaders-kit";
import useAuthStore from "../../../../store/useAuthStore";
import DateRange from "../DateRange";
import ParentBS from "./ParentBS";

const BalanceSheet = () => {
  const [comparisonData, setComparisonData] = useState([]); // Updated state variable
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);


  const { token } = useAuthStore();

  const handleFilteredDataChange = async ({ ranges }) => {
    setLoading(true);
    try {
      const fetchOptions = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      // Get the latest endDate from all ranges to fetch cumulative data up to that point
      const latestEndDate = ranges.reduce((latest, current) => {
        return current.endDate > latest ? current.endDate : latest;
      }, ranges[0].endDate);

      const endDateStr = latestEndDate.toISOString().split("T")[0];
      const startDateStr = "2000-01-01"; // Fetch from "beginning" for opening balances

      const [incomeResponse, expenseResponse] = await Promise.all([
        fetch(`/api/getallIncomes?startDate=${startDateStr}&endDate=${endDateStr}&limit=-1`, fetchOptions),
        fetch(`/api/getallexpense?startDate=${startDateStr}&endDate=${endDateStr}&limit=-1`, fetchOptions),
      ]);

      if (!incomeResponse.ok || !expenseResponse.ok) {
        throw new Error("Failed to fetch data");
      }

      const incomeResult = await incomeResponse.json();
      const expenseResult = await expenseResponse.json();

      const combinedData = [
        ...incomeResult.incomes.map((income) => ({ ...income, type: "income" })),
        ...expenseResult.expenses.map((expense) => ({ ...expense, type: "expense" })),
      ];


      // Map ranges to the format expected by ParentBS/comparisonData
      const comparisonData = ranges.map((range) => {
        return {
          period: [range.startDate, range.endDate],
          data: combinedData, // ParentBS filters internally from this
        };
      });

      setComparisonData(comparisonData);
      setError("");
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Error updating Balance Sheet. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (error) {
    return <div className="text-center text-red-500">{error}</div>;
  }

  return (
    <div>
      <DateRange
        onFilteredDataChange={handleFilteredDataChange}
      />
      {loading ? (
        <div className="flex justify-center items-center min-h-screen">
          <SlidingCubeLoader
            loading={true}
            size={50}
            colors={["#2887D4BE", "#0976C3BE"]}
            duration={1}
          />
        </div>
      ) : (
        <ParentBS comparisonData={comparisonData} />
      )}
    </div>
  );
};

export default BalanceSheet;
